// extracted by mini-css-extract-plugin
module.exports = {"form":"index-module--form--2gUkh","inputs":"index-module--inputs--1XuuT","button":"index-module--button--sTXDy"};